import { useCallback, useMemo } from 'react'
import { prepareTagSlugs } from '@/api/restaurants/get-restaurants-query'
import { ITag } from '@/api/restaurants/types/restaurant-types'
import { useGetAllTagsQuery } from '@/api/tags/get-all-tags-query'
import { IListItem, List } from '@/components/list'
import { useRestaurantCitySearchContext } from '@/features/restaurants/restaurants-city-search/utils/restaurant-city-search-context'

export const RestaurantCitySearchFiltersTagsMobile = () => {
    const {
        city,
        query: { tagSlugs },
        setters: { setTagSlugs },
    } = useRestaurantCitySearchContext()

    const { data } = useGetAllTagsQuery(city?.slug)

    const allTags = data?.data

    const toggleTag = useCallback(
        (tag: ITag) => {
            const prev = prepareTagSlugs(tagSlugs) ?? []

            const nextSlugs = prev.includes(tag.slug)
                ? prev.filter((prevTag) => prevTag !== tag.slug)
                : [...prev, tag.slug]

            setTagSlugs(nextSlugs)
        },
        [tagSlugs, setTagSlugs]
    )

    const tagsList = useMemo<IListItem<ITag>[] | undefined>(() => {
        if (!allTags) return

        return allTags.map<IListItem<ITag>>((tag) => ({
            key: tag.slug,
            id: tag.slug,
            label: tag.name,
            emoji: tag.emoji,
            onClick: () => toggleTag(tag),
            value: tag,
            selected: tagSlugs?.includes(tag.slug),
        }))
    }, [allTags, toggleTag, tagSlugs])

    if (!tagsList) return null

    return <List<ITag> list={tagsList} className="px-5" />
}
